import React from "react";
import { LabelColumn, Row, ValueColumn } from "src/components/shared/Sidebar/SidebarTable";
import { localizeCurrencyToWholeNumber } from "src/utils";
import { AccountDisclaimers } from "Types/api/AccountDisclaimers";

interface Props {
    accountDisclaimers: AccountDisclaimers;
    price: number;
    msrp: number;
    showMsrp: boolean;
}

const Price = ({ accountDisclaimers, price, msrp, showMsrp }: Props) => {
    if (showMsrp && msrp && price === msrp) {
        return null;
    }

    return (
        <Row>
            <LabelColumn>{accountDisclaimers.base_price}</LabelColumn>
            <ValueColumn>{localizeCurrencyToWholeNumber(price)}</ValueColumn>
        </Row>
    );
};

export default Price;
